import type { AccountForChildEligibilityDetails } from '@generated-types';

export const getApplicantParentName = ({
    currentBankCreateShareSavingsAccountEligibility,
}: AccountForChildEligibilityDetails) => currentBankCreateShareSavingsAccountEligibility.applicantParent.name;

export const getApplicantParentFnr = ({
    currentBankCreateShareSavingsAccountEligibility,
}: AccountForChildEligibilityDetails) => currentBankCreateShareSavingsAccountEligibility.applicantParent.fnr.value;

export const getApproverParentName = ({
    currentBankCreateShareSavingsAccountEligibility,
}: AccountForChildEligibilityDetails) => currentBankCreateShareSavingsAccountEligibility.approverParent.name;

export const getApproverParentFnr = ({
    currentBankCreateShareSavingsAccountEligibility,
}: AccountForChildEligibilityDetails) => currentBankCreateShareSavingsAccountEligibility.approverParent.fnr.value;
